module.exports = __webpack_public_path__ + "fonts/7c07a21635c775c7b5605a89715ec3cc.eot";